export default "__VITE_ASSET__DROsEkOP__"